import { ExtensionOption } from '../../extension-register/models/extension-option.interface';

export interface HuntGroupMemberItemView extends ExtensionOption {
   huntGroupMemberId: number;
   extensionHuntGroupId: number;
}

export const huntGroupMemberKeyFields: string[] = ['huntGroupMemberId', 'extensionHuntGroupId', 'extensionId'];
